import { Template } from '@bynder-studio/render-core';
import ProxyServerConnector from '~/services/connectors/ProxyServerConnector';

class TemplatesServiceFromXML extends ProxyServerConnector {
    constructor(path = '/templates') {
        super(path);
    }

    uploadTemplate(formData: FormData) {
        return this.post<Template>(`/xml/convert`, formData);
    }
}

export default new TemplatesServiceFromXML();
